<template>
  <Carousel
    :autoplay="8000"
    :transition="1000"
    :wrapAround="true"
    :pauseAutoplayOnHover="true"
    :settings="settings"
  >
    <Slide v-for="review in slides" :key="review.ID">
      <div class="carousel__item">
        <div class="w-full pb-4">

          <div
            class="prose lg:prose-lg italic lg:pt-6 pb-8 px-8 max-w-5xl w-full antialiased md:px-20"
            v-html="review.preview"
          ></div>

          <p
            class="text-2xl font-script antialiased text-accent"
            v-html="review.title"
          ></p>
          <p
            class="uppercase text-sm text-primary-dark font-bold tracking-wider antialiased"
            v-html="review.source"
          ></p>
        </div>
      </div>
    </Slide>
    <template #addons>
      <!-- <Pagination /> -->
    </template>
  </Carousel>
</template>

<script>
import { defineComponent } from "vue";
import { Carousel, Pagination, Slide } from "vue3-carousel";

import "vue3-carousel/dist/carousel.css";

export default defineComponent({
  name: "ReviewSlider",
  components: {
    Carousel,
    Slide,
    Pagination,
  },
  props: {
    slides: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    settings: {
      itemsToShow: 1,
      itemsToScroll: 1,
      snapAlign: "center",
    },
  }),
});
</script>

<style>
.carousel__pagination {
  margin-top: 20px !important;
}
.carousel__pagination-button {
  background-color: white !important;
  width: 3px;
  height: 3px;
  opacity: 50%;
}
.carousel__pagination-button--active {
  opacity: 100%;
}
</style>
